import AssegneeSuggestions from './AssegneeSuggestions';
import AssegneeSuggestionsProvider from './AssegneeSuggestionsContext';

let Index = () => {
    return (
        <AssegneeSuggestionsProvider>
            <AssegneeSuggestions />
        </AssegneeSuggestionsProvider>
    )
}

export default Index;